import { render, staticRenderFns } from "./EmailShareForm.vue?vue&type=template&id=58a3793c"
import script from "./EmailShareForm.vue?vue&type=script&lang=js"
export * from "./EmailShareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports